import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './../../assets/phone/game4.png';
import _imports_1 from './../../assets/phone/game1.png';
import _imports_2 from './../../assets/phone/game2.png';
import _imports_3 from './../../assets/phone/game3.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-1cdb6f5a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "not-logged-panel" };
var _hoisted_2 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "phone-bg" }, null, -1); });
var _hoisted_3 = { class: "phone-slider" };
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "phone" }, [
    /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 })
], -1); });
var _hoisted_5 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "phone" }, [
    /*#__PURE__*/ _createElementVNode("img", { src: _imports_1 })
], -1); });
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "phone" }, [
    /*#__PURE__*/ _createElementVNode("img", { src: _imports_2 })
], -1); });
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "phone" }, [
    /*#__PURE__*/ _createElementVNode("img", { src: _imports_3 })
], -1); });
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "phone-overlay" }, null, -1); });
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "home-subtitle font-ris" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "Miners Rush is a match-3 game built on CoreDAO blockchain! Match gems, complete challenges, and play in brand-new levels in our daily tournaments for HUUUUGE prizes!")
], -1); });
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_Flicking = _resolveComponent("Flicking");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Flicking, {
                options: { moveType: 'snap', duration: 100, circular: true, bound: true },
                plugins: $data.plugins
            }, {
                default: _withCtx(function () { return [
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7
                ]; }),
                _: 1
            }, 8, ["plugins"]),
            _hoisted_8
        ]),
        _hoisted_9
    ]));
}
